<template>
    <div>
        <!-- DIALOGO DE LOADING -->
        <Dialog :baseZIndex="2" :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }" :modal="true">
            <ProgressBar mode="indeterminate" style="height: 0.5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>
        <div class="card">
            <div class="flex card-container blue-container overflow-hidden">
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-outlined" @click="cierraVentana()" v-tooltip.right="'Cerrar'" />
                </div>
                <h1 class="flex-grow-1 flex align-items-center justify-content-center py-2">{{ detalles.tipo }}</h1>
                <div class="flex-none flex align-items-center justify-content-center py-2">
                    <Button icon="mdi mdi-file-excel-box" class="p-button-rounded p-button-outlined" style="color:#107C41" @click="ExportExcel()" v-tooltip.right="'Exportar Excel'" />
                    <Button icon="mdi mdi-repeat-once" class="p-button-rounded p-button-outlined" style="color:#EA4648" @click="ReporteRepetidos()" v-tooltip.right="'Reporte Repetidos'" v-if="detalles.origen==='ISR'"/>
                </div>
            </div>
            <hr size=7 color="#FF6699">
        </div>
        <div class="card">
            <DataTable :value="detalles.detalles" :scrollable="true" scrollHeight="flex" scrollDirection="both" :paginator="true" :rows="10" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,20,50]"
            currentPageReportTemplate="{first} a {last} de {totalRecords}" responsiveLayout="scroll">
            <!-- <Column header="Acciones" :styles="{'width':'1rem', 'min-width':'5rem'}" :exportable="false">
                <template #body="slotProps">
                    <Button icon="mdi mdi-file-pdf-box" class="p-button-text p-button-rounded" v-tooltip.bottom="'PDF'" @click="OpenPdf(slotProps.data, 'Sueldos y Salarios')" style="color:#FE0000"/>
                </template>
            </Column> -->
                <Column field="serie" header="Serie" sortable :styles="{'width':'5rem', 'min-width':'5rem'}"></Column>
                <Column field="folio" header="Folio" sortable :styles="{'width':'5rem', 'min-width':'5rem'}"></Column>
                <Column field="rfc" header="RFC" sortable :styles="{'width':'10rem', 'min-width':'10rem'}"></Column>
                <Column field="nombre" header="Nombre" sortable :styles="{'width':'15rem', 'min-width':'15rem'}"></Column>
                <template v-if="detalles.origen==='TRABAJADORES'">
                    <Column field="fecha" header="Fecha" sortable :styles="{'width':'10rem', 'min-width':'10rem'}">
                        <template #body="{ data }">
                            <span>{{ formtaDate(data.fecha) }}</span>
                          </template>
                    </Column>
                </template>
                <Column field="fechaPago" header="Fecha de Pago" sortable :styles="{'width':'10rem', 'min-width':'10rem'}">
                    <template #body="{ data }">
                        <span>{{ formtaDate(data.fechaPago) }}</span>
                      </template>
                </Column>
                <template v-if="detalles.origen==='TRABAJADORES'">
                    <Column field="fechaInicial" header="Fecha Inicial" sortable :styles="{'width':'10rem', 'min-width':'10rem'}">
                        <template #body="{ data }">
                            <span>{{ formtaDate(data.fechaInicial) }}</span>
                          </template>
                    </Column>
                    <Column field="fechaFinal" header="Fecha Final" sortable :styles="{'width':'10rem', 'min-width':'10rem'}">
                        <template #body="{ data }">
                            <span>{{ formtaDate(data.fechaFinal) }}</span>
                          </template>
                    </Column>
                </template>
                <template v-if="detalles.origen==='ISR'">
                    <Column field="totalImpuestosRetenidos" header="ISR" sortable :styles="{'width':'10rem', 'min-width':'10rem'}">
                        <template #body="{ data }">
                            <span>{{ formatCurrency(data.totalImpuestosRetenidos) }}</span>
                          </template>
                    </Column>
                </template>
                <template v-if="detalles.origen==='TRABAJADORES'">
                    <Column field="totalPercepciones" header="Total Percepciones" sortable :styles="{'width':'10rem', 'min-width':'10rem'}">
                        <template #body="{ data }">
                            <span>{{ formatCurrency(data.totalPercepciones) }}</span>
                          </template>
                    </Column>
                    <Column field="totalDeducciones" header="Total Deducciones" sortable :styles="{'width':'10rem', 'min-width':'10rem'}">
                        <template #body="{ data }">
                            <span>{{ formatCurrency(data.totalDeducciones) }}</span>
                          </template>
                    </Column>
                    <Column field="totalOtrosPagos" header="Total Otros Pagos" sortable :styles="{'width':'10rem', 'min-width':'10rem'}">
                        <template #body="{ data }">
                            <span>{{ formatCurrency(data.totalOtrosPagos) }}</span>
                          </template>
                    </Column>
                    <Column field="total" header="Total" sortable>
                        <template #body="{ data }">
                            <span>{{ formatCurrency(data.total) }}</span :styles="{'width':'10rem', 'min-width':'10rem'}">
                          </template>
                    </Column>
                </template>
                <Column field="tipoRegimen" header="Tipo Régimen" sortable :styles="{'width':'5rem', 'min-width':'5rem'}"></Column>
                <Column field="tipoNomina" header="Tipo Nómina" sortable :styles="{'width':'10rem', 'min-width':'10rem'}"></Column>
                <Column field="periodicidad" header="Periodicidad" sortable :styles="{'width':'10rem', 'min-width':'10rem'}"></Column>
                <Column field="folioFiscal" header="Folio Fiscal" sortable></Column>
            </DataTable>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import moment from 'moment'
    import { FilterMatchMode, FilterOperator } from "primevue/api/";
    import XLSX from 'xlsx'
    export default {
        components: {
            
        },
        data() {
            return {
                loading: false,
                loadingMensaje: '',
            }
        },
        computed: {
            token() {
                return this.$store.state.usuario;
            },
            
            detalles(){
                return this.$store.state.isrDetallesStore;
            },
        },
        created() {

        },
        methods: {
            formatCurrency(value) {
                return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            },

            formtaDate(value){
                moment.locale('es-mx');
                return moment(value).format('DD-MMMM-YYYY')
            },

            cierraVentana(){
                this.$emit('closeDialogComparativa')
            },

            ExportExcel(){
                const workbook = XLSX.utils.book_new();
                const sheet = XLSX.utils.json_to_sheet(this.detalles.detalles);
                XLSX.utils.book_append_sheet(workbook, sheet, 'Hoja1');
                XLSX.writeFile(workbook, this.detalles.origen + ' ' + this.detalles.tipo + '.xlsx');
            },

            async OpenPdf(item){
                console.log(this.token)
                try{
                    let response = await axios.get('https://localhost:44322/api/Comprobante/GetComprobanteAsync/' + this.token.empresaBase + '/' + item.folioFiscal);
                    console.log(response.data)
                    let datos = response.data;
                }catch(error){
                    console.log(error);
                }
            },

            BuscaRepetidos(obj1, obj2){
                return(
                    obj1.rfc === obj2.rfc &&
                    obj1.tipoNomina === obj2.tipoNomina &&
                    obj1.fechaPago === obj2.fechaPago
                );
            },

            ReporteRepetidos(){
                let lista = [ ...this.detalles.detalles ]
                const elementosRepetidos = lista.filter((elemento, index) => {
                    return (
                        lista.findIndex((item) => this.BuscaRepetidos(item, elemento)) !== index
                    );
                });

                const workbook = XLSX.utils.book_new();
                const sheet = XLSX.utils.json_to_sheet(elementosRepetidos);
                XLSX.utils.book_append_sheet(workbook, sheet, 'Hoja1');
                XLSX.writeFile(workbook, 'Reporte ISR ' + this.detalles.tipo + '_Repetidos.xlsx');

                // console.log(elementosRepetidos);
            },
        },
    }
</script>